const win: any = window;
// 网页中调用回流方法跳转ths
export const handlePageToThs = () => {
  // 模拟用户点击回流组件
  const dom: any = document.getElementsByClassName('openBtn');
  if (dom.length > 0) {
      dom[0].click();
  }
}

// 去掉ios弹性下拉
export function removeIosBounce() {
  win.callNativeHandler('notifyWebHandleEvent', {
    method: 'WebviewBounce',
    params: { bounce: 0 },
  });
}
